import React, { FunctionComponent, useMemo } from "react";
import { utcToZonedTime } from "date-fns-tz";
import { IventisCellRendererParams } from "../types/data-table.types";
import { TextCellContents } from "./text-cell-renderer";

export const DateCellRenderer: FunctionComponent<IventisCellRendererParams> = ({ value }) => {
    const displayText = useMemo(() => {
        if (value == null) {
            return "";
        }
        const parsedDate = utcToZonedTime(value, "UTC").toLocaleDateString("en-gb");
        if (parsedDate === "Invalid Date") {
            return "";
        }

        return parsedDate;
    }, [value]);
    return (
        <TextCellContents style={{ minWidth: "140px" }} valid>
            {displayText}
        </TextCellContents>
    );
};
